export default __webpack_public_path__ + "static/Gilroy-Regular-a3c2b855b67d26a06217a4d62ff1eca5.woff";